module.exports = __webpack_public_path__ + "media/images/chats/mariam-torn-apart-all-photos-and-docs.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/chats/mariam-torn-apart-all-photos-and-docs.jpg
// module id = 78
// module chunks = 0